import axiosInstance from "./axiosInstance";

export const obtenerFinanzas = async (search, page, limit) => {
    const params = new URLSearchParams();
    if (search) {
        params.append('search', search);
    }
    if (page) {
        params.append('page', page);
    }
    if (limit) {
        params.append('limit', limit);
    }
    return await axiosInstance.get(
        `${process.env.REACT_APP_BASE_URL}/finanzas/finanza?${params.toString()}`,
        { withCredentials: true }
    );
}

export const obtenerFinanzasRegistro = async ({search, page, limit, idUser, category, startDate, endDate, full = false}) => {
    const params = new URLSearchParams();
    if (search) {
        params.append('search', search);
    }
    if (page) {
        params.append('page', page);
    }
    if (limit) {
        params.append('limit', limit);
    }
    if (idUser) {
        params.append('idUser', idUser);
    }
    if (category) {
        params.append('category', category);
    }
    if (startDate) {
        params.append('startDate', startDate);
    }
    if (endDate) {
        params.append('endDate', endDate);
    }

    if(full){
        params.append('full', 'true')
    }
    
    return await axiosInstance.get(
        `${process.env.REACT_APP_BASE_URL}/finanzas?${params.toString()}`,
        { withCredentials: true }
    );
}

export const obtenerCategorias = async () => {
    return await axiosInstance.get(
        `${process.env.REACT_APP_BASE_URL}/finanzas/categorias`,
        { withCredentials: true }
    );
}

export const postFinanza = async (data) => {
    return await axiosInstance.post(
        `${process.env.REACT_APP_BASE_URL}/finanzas/finanza`,
        data,
        { withCredentials: true }
    );
}

export const postRegistroFinanzaMultiple = async (data) => {
    return await axiosInstance.post(
        `${process.env.REACT_APP_BASE_URL}/finanzas/multiple`,
        data,
        { withCredentials: true }
    );
}

export const postRegistroFinanza = async (data) => {
    return await axiosInstance.post(
        `${process.env.REACT_APP_BASE_URL}/finanzas`,
        data,
        { withCredentials: true }
    );
}

export const deleteFinanza = async (id) => {
    return await axiosInstance.delete(
        `${process.env.REACT_APP_BASE_URL}/finanzas?id=${id}`,
        { withCredentials: true }
    );
}

export const downloadTemplate = async () => {
    return await axiosInstance.get(
        `${process.env.REACT_APP_BASE_URL}/finanzas/template`,
        { 
            withCredentials: true,
            responseType: 'blob', // Ensure the response is treated as a Blob
            headers: {
                
                'Cache-Control': 'no-cache', 
                'Pragma': 'no-cache', 
            },
        }
    );
}